import { View } from "@/components/ui";
import { ActionNavigation } from "@/components/shared/booking/action-navigation";
import { useBookingRoute } from "@/components/hooks/use-booking-route";
import { NativeActionNavigation } from "@/components/shared/booking/native-action-navigation";
import type { ServiceName } from "@/types/service";

export const SelectServiceNavigation = ({ name }: { name: ServiceName }) => {
  const { forward } = useBookingRoute();
  const onClickButton = () => {
    forward();
  };
  return (
    <View>
      <ActionNavigation
        buttonText="Select Services"
        onClickButton={onClickButton}
      />
      <NativeActionNavigation
        name={name}
        buttonText="Select Services"
        onClickButton={onClickButton}
      />
    </View>
  );
};
